import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Grid, IconButton, Tab, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useLocation } from 'react-router-dom';
import Manufacturer from './ManufacturerList';
import Material from './MaterialList';
import Vendor from './VendorList';

const Admin: React.FC = () => {
  const [value, setValue] = React.useState<any>();
  const location = useLocation();
  const selectedTab = location.state?.selectedTab;

  React.useEffect(() => {
    if (selectedTab !== undefined) {
      setValue(selectedTab);
    } else {
      setValue('1');
    }
  }, [selectedTab]);

  // 1️⃣ define tabs, conditionally include Subcontractor
  const tabs = [
    { label: 'Manufacturers', value: '1', component: <Manufacturer /> },
    { label: 'Vendors', value: '2', component: <Vendor /> },
    { label: 'Materials', value: '3', component: <Material /> },
  ];

  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 4, sm: 2, md: 2 }}>
        <Grid
          item
          xs={12}
          sm={12}
          // md={showNotes && isProjectHubActive && FEATURE_FLAGS.projectHub_v1_enable ? 10 : 12}
          style={{ cursor: 'pointer', height: '100%' }}
        >
          <Box sx={{ width: '100%', typography: 'body1', marginLeft: '0px' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  onChange={(e, newValue) => {
                    //setCurrentPageDetails(location.pathname, newValue, undefined);
                    setValue(newValue);
                  }}
                  aria-label="admin management tabs"
                >
                  {tabs.map((tab) => (
                    <Tab sx={{ textTransform: "none" }} key={tab.value} label={tab.label} value={tab.value} />
                  ))}
                </TabList>
              </Box>
              {tabs.map((tab) => (
                <TabPanel key={tab.value} value={tab.value}>
                  {tab.component}
                </TabPanel>
              ))}
            </TabContext>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Admin;
